import operationalStatuses from './operationalStatuses';
function statusColors(status) {
	switch (status) {
	case operationalStatuses.draft:
		return 'gray';
	case operationalStatuses.ready:
	case operationalStatuses.planned:
		return 'blue';
	case operationalStatuses.rejected:
	case operationalStatuses.unsuccessful:
		return 'red';
	case operationalStatuses.received:
	case operationalStatuses.requested:
		return 'orange';
	case operationalStatuses.accepted:
	case operationalStatuses.readyForPickup:
		return 'yellow';
	case operationalStatuses.loaded:
		return 'green';
	case operationalStatuses.unloaded:
		return 'neutral';
	case operationalStatuses.cancelled:
	default:
		return 'gray';
	}
}

export default statusColors;